<script setup lang="ts">
import { onLaunch, onShow, onHide } from '@dcloudio/uni-app';
import useAuthStore from './stores/auth';
import { useUserStore } from './stores/user';
import { useSystemStore } from './stores/system';
import router from './router';
import { APP_BASE_URL } from './constant/vite_env';
import { parseQuery } from './utils/tools';
import storage from './utils/storage';
// 白名单名单路径
const whiteList = ['403', 'bindPhone', 'noTenant', 'M_2'];

onLaunch(async () => {
    console.log('App Launch');
    const { wxTenantId, userId, tenantId, token, refreshToken } = parseQuery();
    const authStore = useAuthStore();
    const userStore = useUserStore();
    const systemStore = useSystemStore();
    const lastApp = storage.get('lastApp');
    if (lastApp !== 'ltnciq') {
        storage.clear();
        storage.set('lastApp', 'ltnciq');
    }
    if (wxTenantId && userId) {
        const routerBaseUrl = APP_BASE_URL;
        const wxToPath = window.location.pathname + window.location.search;
        storage.set('wxTenantId', wxTenantId);
        storage.set('userId', userId);
        storage.set('wxToPath', wxToPath.indexOf('/login') > -1 ? '/' : wxToPath.replace(routerBaseUrl, '/'));
    }
    if (tenantId && token && refreshToken) {
        storage.set('tenantId', tenantId);
        storage.set('token', token);
        storage.set('wxTenantId', tenantId);
        storage.set('refreshToken', refreshToken);
    }
    authStore.initToken();
    // 页面刷新时重新获取用户信息
    const _token = storage.get('token') || undefined;
    console.log(authStore.getToken, _token, 'authStore.getToken');
    if (authStore.getToken) {
        await userStore.initUser();
    }
    console.log(userStore.getUser?.permissions, router.route);
    // 首次进入检查登陆态与路由权限
    if (authStore.getToken) {
        await systemStore.initSystem();
        // 有登录态且当前是登录页或者无权限页，跳转到首页
        if (
            window.location.pathname === APP_BASE_URL ||
            window.location.pathname === APP_BASE_URL + 'mobile/login/index' ||
            window.location.pathname === APP_BASE_URL + 'mobile/auth/index'
        ) {
            router.pushTab({ name: 'M_2' });
            return;
        }
        // 有登录态检查当前页面权限,无权限前往提示页，有权限不做任何处理，交给当前页面处理(流程表单页不用检查权限)
        if (
            userStore.getUser?.permissions?.indexOf(router.route.value.name as string) === -1 &&
            (router.route.value.name?.indexOf('mobile_') as number) === -1 &&
            whiteList.indexOf(router.route.value.name as string) === -1
        ) {
            router.replaceAll({ name: '403' });
        }
    }
});
onShow(() => {
    console.log('App Show');
});
onHide(() => {
    console.log('App Hide');
});
</script>
<style lang="less">
@import 'less/variable.less';
@import 'less/common.less';
@import 'less/base.less';
</style>
